<template>
<vs-popup
  title="Aceitação de Termos"
  :active="isPopupActive"
  :button-close-hidden="true"
>
  <div v-if="pdfList.length" class="device-buttons-wp" ref="acceptanceTerm">
    <vs-button    
      v-for="(item, index) in pdfList"
      :key="`popup-${item.label}`"
      color="primary"
      @click="statusCurrentPdf(item)"    
      type="flat" 
      :icon="index ? 'assignment' : 'description'"
      size="small"
      class="mr-3 device-button"
      style="max-width: 15rem;"
    >
      {{ item.label }}
    </vs-button>
  </div>

  <div class="text-center mt-2 mb-2" v-if="currentPdf">
    <vs-button
      type="flat"
      @click="previousPdfPage"
      :disabled="currentPage === 1"
    >
      &#60; Anterior
    </vs-button>
    
    <span class="ml-3 mr-3">{{currentPage}} / {{pageCount}}</span>

    <vs-button
      type="flat"
      @click="nextPdfPage"
      :disabled="currentPage === pageCount"
    >
      Próxima &#62;
    </vs-button>
  </div>

  <pdf
    v-if="currentPdf || pdfList.length"
    :page="currentPage"
    @num-pages="pageCount = $event"
    @page-loaded="currentPage = $event"
    :src="currentPdf"
  />

  <div class="text-center mt-2 mb-2" v-if="currentPdf">
    <vs-button
      type="flat"
      @click="previousPdfPage"
      :disabled="currentPage === 1"
    >
      &#60; Anterior
    </vs-button>
    
    <span class="ml-3 mr-3">{{currentPage}} / {{pageCount}}</span>

    <vs-button
      type="flat"
      @click="nextPdfPage"
      :disabled="currentPage === pageCount"
    >
      Próxima &#62;
    </vs-button>
  </div>

  <hr/>

  <div>
    <p class="mb-3 mt-3" v-if="tabActive=='Contrato de Prestação de Serviços'">
      Você está de acordo com a Contrato de Prestação de Serviços e o contrato?
    </p>
    <p class="mb-3 mt-3" v-if="tabActive=='Regras'">Você está de acordo com as regras?</p>

    <vs-button
      type="filled"
      color="danger"
      style="float: left"
      @click="logout"
    >
      Recusar
    </vs-button>

    <vs-button
      v-if="tabActive=='Contrato de Prestação de Serviços'"
      type="filled"
      color="success"
      style="float: right"
      @click="acceptContract"
    >
      Aceitar
    </vs-button>

    <vs-button
      v-if="tabActive=='Regras'"
      type="filled"
      color="success"
      style="float: right"
      @click="signContractRule"
    >
      Aceitar
    </vs-button>
  </div>
</vs-popup>
</template>

<script>
import pdf from 'vue-pdf'
import { formatRouteTenantPath } from '@/utils'
import moduleContract from '@/store/contract/moduleContract'

export default {
  data() {
    return {
      isPopupActive: false,
      currentPdf: '',
      tabActive: 'Contrato de Prestação de Serviços',
      contractInfos: {},
      pdfList: [],
      currentPage: 1,
      pageCount: 1,
    }
  },
  methods: {
    setData() {
      this.contractInfos = this.$store.state.contract.contract

      if (!this.contractInfos.contract_signed_at || !this.contractInfos.contract_subscriber_ip) {
        this.isPopupActive = true

        this.pdfList.push({
          label: 'Contrato de Prestação de Serviços',
          value: this.contractInfos.proposal_pdf_url
        })

         this.pdfList.push({                    
          label: 'Regras',
          value: this.contractInfos.contract_pdf_url
        })
                
        this.currentPdf = this.contractInfos.proposal_pdf_url
      } else {
        this.isPopupActive = false
      }
    },
    statusCurrentPdf(item){
      this.currentPdf = item.value;
      this.tabActive=item.label      
      this.$nextTick(() => {
        this.$refs.acceptanceTerm.scrollIntoView();        
      })
      this.currentPage=1;
    },
    acceptContract(){
      let item={
        label: 'Regras',
        value: this.contractInfos.contract_pdf_url
      }
      
      this.statusCurrentPdf(item);      
    },
    signContractRule() {      
      this.$store.dispatch("contract/signContract")
      .then(() => { this.closeContractPopup() })
      .catch(err => { console.error(err) })
    },
    logout() {
      this.closeContractPopup().then(() => {
        if (localStorage.getItem("accessToken")) {
          this.$store.dispatch("auth/disconnected").then(() => {
            localStorage.removeItem("accessToken")
            localStorage.removeItem("groupsSelectedFilter")
            this.$router.push(formatRouteTenantPath('/login'))
          })
        }

        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change('administrador')
        localStorage.removeItem('userInfo')

        // This is just for demo Purpose. If user clicks on logout -> redirect
        this.$router.push(formatRouteTenantPath('/login'))
      })
    },
    closeContractPopup() {
      this.isPopupActive = false  
      return Promise.resolve({})
    },
    previousPdfPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPdfPage() {
      if (this.currentPage < this.pageCount) {
        this.currentPage++
      }
    }
  },
  created() {
    if (!moduleContract.isRegistered) {
      this.$store.registerModule('contract', moduleContract)
      moduleContract.isRegistered = true
    }

    this.$store.dispatch("contract/contractInfos").then(() => {
      this.setData()
    })
  },
  components: {
    pdf
  }
}
</script>

<style scoped>
.device-buttons-wp {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.device-button {
  font-size: 1em !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
